import { AxiosResponse } from 'axios'
import dayjs from 'dayjs'

import { Holiday } from 'types/common'

import { _axiosMain } from './axios'

const GET_HOLIDAYS = `/common/holidays`

export const commonApi = () => {
  const getHolidays = async (): Promise<AxiosResponse<Holiday[]>> => {
    return await _axiosMain()
      .get(GET_HOLIDAYS)
      .then((res) => {
        res.data = res.data.holidays.map((holiday: Holiday) => ({
          ...holiday,
          date: dayjs(holiday.date),
        }))
        return res
      })
  }

  return {
    getHolidays,
  }
}
